import { useUIConfigStore } from '@/stores/uiConfigStore'

export function useUIConfig() {
  const { hiddenNavItems, setNavItemVisible } = useUIConfigStore()
  return { hiddenNavItems, setNavItemVisible }
}
